import { OfferInterface } from 'app/shared/interfaces/Offer.interface';
import { InsurerNameEnum, InsurersEnum } from 'app/shared/enums';

export function getInsurerNameAfterRebranding(
  insurerName: OfferInterface['insurerName']
) {
  switch (insurerName) {
    case InsurersEnum.Axa:
      return InsurersEnum.Uniqa;
    case InsurersEnum.Wefox:
      return InsurerNameEnum.Direct;
    default:
      return insurerName;
  }
}
